export default ".disabledBtn {\n  opacity: 0.5;\n}"